<template>
  <router-view />
</template>

<script>
export default {
  name: "Route",
};
</script>
